import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { Box, Button, DataTable } from '../../../../common/components';
import {
  applyFilter,
  fetchData,
  refreshData,
} from '../../../../common/components/DataTable/redux/dataTableActions';
import { Link } from 'react-router';
import { get, indexOf, pull } from 'lodash';
import { formValueSelector, reduxForm } from 'redux-form';
import { changeEndDates } from '../../redux/campaignActions';
import CampaignsStatusFilter from './Filters/CampaignsStatusFilter';
import * as moment from 'moment/moment';
import { openModal } from '../../../../common/components/Modal/ModalRedux';
import { AmendCampaignEndDateModal } from '../AmendCampaignEndDateModal';
import { InternalButtonBar } from '../../../layout/components/InternalButtonBar/InternalButtonBar';
import formatDate from '../../../../helpers/formatDate';
import './styles.scss';

/********************
 Campaign DataTable
 *********************/

class Campaigns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
      selectedRows: null,
      items: [],
    };

    this.handleSearchStartDate = this.handleSearchStartDate.bind(this);
    this.handleSearchEndDate = this.handleSearchEndDate.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.applyEndDates = this.applyEndDates.bind(this);
    // this.closeModal = this.closeModal.bind(this);
    // this.openModal = this.openModal.bind(this)
  }

  refreshList() {
    this.props.dispatch(refreshData('campaigns'));
  }

  handleRowClick(row) {
    let newArr = [...this.state.items];
    if (indexOf(this.state.items, row.id) !== -1) {
      pull(newArr, row.id);
      this.setState(() => ({
        items: newArr,
      }));
    } else {
      this.setState((prevState) => ({
        items: [...prevState.items, row.id],
      }));
    }
  }

  applyEndDates(values) {
    Promise.resolve(
      this.props.dispatch(changeEndDates(this.state.items, values.meta.to_date)),
    ).then(() => {
      this.props.dispatch(fetchData('campaigns'));
    });

    this.setState(() => ({
      closeModal: false,
    }));
  }

  handleSearchUpdate(event) {
    this.props.dispatch(applyFilter('campaigns', 'filter[name]', event.target.value));
  }

  handleTypeFilterUpdate(option) {
    this.props.dispatch(
      applyFilter('campaigns', 'filter[campaign_type]', option ? option.value : ''),
    );
  }

  handleStatusFilterUpdate(option) {
    this.props.dispatch(
      applyFilter('campaigns', 'filter[status]', option ? option.value : ''),
    );
  }

  handleSearchStartDate(event) {
    const searchString = 'filter[from_date:gte]';
    const formattedDate = moment(event.target.value, 'DD/MM/YYYY').utcOffset(0, true);
    if (formattedDate.isValid()) {
      this.props.dispatch(applyFilter('campaigns', searchString, formattedDate.format()));
    } else {
      this.props.dispatch(applyFilter('campaigns', searchString, ''));
    }
  }

  handleSearchEndDate(event) {
    const searchString = 'filter[to_date:lte]';
    const formattedDate = moment(event.target.value, 'DD/MM/YYYY').utcOffset(0, true);
    if (formattedDate.isValid()) {
      this.props.dispatch(applyFilter('campaigns', searchString, formattedDate.format()));
    } else {
      this.props.dispatch(applyFilter('campaigns', searchString, ''));
    }
  }

  render() {
    const formatBanner = (cell) => {
      return <span>{get(cell, 'banner', false) ? 'Yes' : 'No'}</span>;
    };

    const linkToProduct = (cell, row) => {
      return (
        <div>
          <Link style={{ color: '#3c7696' }} to={'/admin/campaigns/' + row.id}>
            {' '}
            {cell}{' '}
          </Link>
        </div>
      );
    };
    return (
      <Box>
        <Row className="filter-container">
          <Col sm={4}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={::this.handleSearchUpdate} />
          </Col>
          <Col sm={4}>
            <ControlLabel>Type</ControlLabel>
            <CampaignsStatusFilter
              onChange={(option) => this.handleTypeFilterUpdate(option)}
              typeFilter
            />
          </Col>
          <Col sm={4}>
            <ControlLabel>Status</ControlLabel>
            <CampaignsStatusFilter
              onChange={(option) => this.handleStatusFilterUpdate(option)}
              statusFilter
            />
          </Col>
        </Row>
        <DataTable
          clickToSelect={false}
          hideCheckBox={false}
          source="/campaigns"
          name="campaigns"
          showTotal
          onRowSelect={this.handleRowClick}
          onSelectAll={this.onSelectAll}
          autoFilters={[{ type: 'filter[status]', value: 'active' }]}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn
            dataField="name"
            dataSort
            width={'20%'}
            dataFormat={linkToProduct}
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn dataField="code" dataSort width={'15%'}>
            Code
          </TableHeaderColumn>

          <TableHeaderColumn dataField="campaign_type" dataSort width={'20%'}>
            Type
          </TableHeaderColumn>

          <TableHeaderColumn dataField="status" dataSort={false} width={'10%'}>
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="metadata"
            dataSort={false}
            dataFormat={formatBanner}
            width={'10%'}
          >
            Banner
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="from_date"
            dataSort
            dataFormat={formatDate}
            width={'10%'}
          >
            Start Date
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="to_date"
            dataSort
            dataFormat={formatDate}
            width={'10%'}
          >
            End Date
          </TableHeaderColumn>
        </DataTable>

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['marketing.campaign_create'],
                  button: (
                    <Button
                      link
                      to="/admin/campaign/new"
                      className="pull-right"
                      bsStyle="primary"
                      label="new campaign"
                    />
                  ),
                },
                {
                  permissions: ['marketing.campaign_end'],
                  button: (
                    <Button
                      handleClick={() =>
                        this.props.dispatch(openModal('amendCampaignEndDateModal'))
                      }
                      bsStyle="primary"
                      className="pull-right pad-right"
                      label="Amend End Date"
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
        <AmendCampaignEndDateModal
          campaignIds={this.state.items}
          callback={::this.refreshList}
        />
      </Box>
    );
  }
}

const FORM_NAME = 'Campaigns';
const form = reduxForm({ form: FORM_NAME })(Campaigns);
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state) => {
  const values = selector(state, 'meta', 'data');
  return {
    formValues: values,
    dataTables: state.dataTables,
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(form);
